<div class="flex flex-col justify-center items-center w-full  h-fit">
  <img class="avatar" [style]="getStyles()" [src]="src || defaultAvatar"/>
</div>
